import { useCallback, useRef } from "react";
import { createPortal } from "react-dom";
import * as React from "react";
export function MountPortal({ content, loader, children }) {
    const portalRootRef = useRef();
    if (!portalRootRef.current) {
        portalRootRef.current = document.createElement("div");
    }
    const mountPortal = useCallback((root) => {
        if (!root || !portalRootRef.current) {
            return;
        }
        root.appendChild(portalRootRef.current);
    }, []);
    return (React.createElement(React.Fragment, null,
        content ? content(React.createElement("div", { ref: mountPortal })) : loader === null || loader === void 0 ? void 0 : loader(React.createElement("div", { ref: mountPortal })),
        createPortal(React.createElement(React.Fragment, null, children), portalRootRef.current)));
}
